import { SAT_BOOTCAMP_SERIES_TEMPLATE_SLUGS } from '@/client/services/satBootcamp/constants'
import type { SATBootcampTemplateSlug } from '@/client/services/satBootcamp/types'

export default function isSATBootcampTemplateSlug(
  slug?: string | null
): slug is SATBootcampTemplateSlug {
  return slug != null && SAT_BOOTCAMP_SERIES_TEMPLATE_SLUGS.includes(slug)
}
